import { ProcessEnvConfig } from "config/ProcessEnvConfig";
import { CAMPAIGN_CONTENT_PAGE_ANCHOR_KEY } from "./CampaignAnchorConfig";

export const STAMP_CAMPAIGN_CONTENT_PAGE_ANCHOR_KEY = {
  ...CAMPAIGN_CONTENT_PAGE_ANCHOR_KEY,
  keyVisual: {
    ...CAMPAIGN_CONTENT_PAGE_ANCHOR_KEY.keyVisual,
    sectionContent: {
      ...CAMPAIGN_CONTENT_PAGE_ANCHOR_KEY.keyVisual.sectionContent,
      "stamp_campaign_upload_stamp_icon_key": "stamp_campaign_upload_stamp_icon_key"
    }
  },
}

export const STAMP_CAMPAIGN_RULE_PAGE_ANCHOR_KEY = {
  tasks: {
    sectionKey: "tasks",
    sectionContent: {
      stamp_tasks_key: "stamp_tasks_key"
    }
  }
}

export const STAMP_CAMPAIGN_REWARDS_PAGE_ANCHOR_KEY = {
  rewards: {
    sectionKey: "rewards",
    sectionContent: {
      reward_section_key: "reward_section_key"
    },
  },
  executionPriority: {
    sectionKey: "executionPriority",
    sectionContent: {
      execution_priority_input_key: "execution_priority_input_key",
    },
  },
}

export const STAMP_CAMPAIGN_PREVIEW_PAGE_ANCHOR_KEY = {
  campaignContent: {
    sectionKey: "perviewContent",
  },
  properties: {
    sectionKey: "perviewProperties",
  },
  rewards: {
    sectionKey: "perviewRewards",
  },
  detailGeneral: {
    sectionKey: "detailGeneral",
  },
};

export const stampCampaignAnchorConfig = [
  {
    title: "Campaign content",
    anchorKey: STAMP_CAMPAIGN_PREVIEW_PAGE_ANCHOR_KEY.campaignContent.sectionKey,
    className: "",
    sublist: [
      {
        anchorKey: STAMP_CAMPAIGN_CONTENT_PAGE_ANCHOR_KEY.general.sectionKey,
        title: "General"
      },
      {
        anchorKey: STAMP_CAMPAIGN_CONTENT_PAGE_ANCHOR_KEY.targetCustomers.sectionKey,
        title: "Target customers"
      },
      {
        anchorKey: STAMP_CAMPAIGN_CONTENT_PAGE_ANCHOR_KEY.keyVisual.sectionKey,
        title: "Key visual"
      },
      {
        anchorKey: STAMP_CAMPAIGN_CONTENT_PAGE_ANCHOR_KEY.instruction.sectionKey,
        title: "Instruction"
      },
      {
        anchorKey: STAMP_CAMPAIGN_CONTENT_PAGE_ANCHOR_KEY.detail.sectionKey,
        title: "Detail"
      },
      {
        anchorKey: STAMP_CAMPAIGN_CONTENT_PAGE_ANCHOR_KEY.campaignListingSection.sectionKey,
        title: "Front end display"
      },
      ...(
        ProcessEnvConfig.haveShopMall
          ? [{ anchorKey: STAMP_CAMPAIGN_CONTENT_PAGE_ANCHOR_KEY.mall.sectionKey, title: 'Mall' }]
          : []
      ),
      {
        anchorKey: STAMP_CAMPAIGN_CONTENT_PAGE_ANCHOR_KEY.activePeriod.sectionKey,
        title: "Active period"
      },
      {
        anchorKey: STAMP_CAMPAIGN_CONTENT_PAGE_ANCHOR_KEY.visiblePeriod.sectionKey,
        title: "Visible period"
      },
      {
        anchorKey: STAMP_CAMPAIGN_CONTENT_PAGE_ANCHOR_KEY.recurringCampaign.sectionKey,
        title: "Recurring Campaign"
      },
    ]
  },
  {
    title: "Rule & Properties",
    anchorKey: STAMP_CAMPAIGN_PREVIEW_PAGE_ANCHOR_KEY.properties.sectionKey,
    className: "",
    sublist: [
      {
        anchorKey: STAMP_CAMPAIGN_RULE_PAGE_ANCHOR_KEY.tasks.sectionKey,
        title: "Task"
      },
    ]
  },
  {
    title: "Rewards",
    anchorKey: STAMP_CAMPAIGN_PREVIEW_PAGE_ANCHOR_KEY.rewards.sectionKey,
    className: "",
    sublist: [
      {
        anchorKey: STAMP_CAMPAIGN_REWARDS_PAGE_ANCHOR_KEY.rewards.sectionKey,
        title: "Reward"
      },
      {
        anchorKey: STAMP_CAMPAIGN_REWARDS_PAGE_ANCHOR_KEY.executionPriority.sectionKey,
        title: "Execution priority for global limit"
      },
    ]
  }
];
